import { render, staticRenderFns } from "./myMessages.vue?vue&type=template&id=327c41b2&scoped=true"
import script from "./myMessages.vue?vue&type=script&lang=js"
export * from "./myMessages.vue?vue&type=script&lang=js"
import style0 from "./myMessages.vue?vue&type=style&index=0&id=327c41b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327c41b2",
  null
  
)

export default component.exports